import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import { XAlignType } from '../../framework.core/XExportColumn';
import { JobNames } from '../../framework.core/JobNames';

export class AiCenterListItem extends SearchModelBase {
    id: number = 0;
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    source: string = '';
    sender: string = "";
    subject: string = "";
    attachment: string = "";
    category : string = '';
    droppedBy: string = '';
    
    //result: string ="";
    //blNo: string = "";
    jobName: string = '';
    jobId: number = 0;  // isfId, hblId, CrDbid, billId, invoiceId
    //isf
    shipmentId: string = "";
    //isfId: number = 0;
    isfType: string = "";
    //
    //action: string = "";
    mblNo: string = '';
    hblNo: string = '';
    //hblId: number = 0;
    refNo: string = '';

    parentJobName: string = '';
    parentJobId: number = 0;
    //type: string = '';
    //invoiceId : number = 0;
    invoiceNo : string = '';  //pt260808
    actionNo: string = '';
    suntekId: string = '';
    error: string = '';
    
    private static ExportCollection: XCol.XExportColumn[] = [
      XCol.Create({ col: 0, text: 'Date', width: 100, dataIndex: 'createdAt',type: XCol.XCellType.DateTime,}),
      XCol.Create({ col: 1, text: 'Sender', width: 210, dataIndex: 'sender'}),
      XCol.Create({ col: 2, text: 'Subject', width: 420, dataIndex: 'subject'}),
      XCol.Create({ col: 3, text: 'Attachment', width: 280, dataIndex: 'attachment'}),
      XCol.Create({ col: 4, text: 'Result', width: 110, dataIndex: 'category'}),
      //XCol.Create({ col: 5, text: 'Type', width: 100, dataIndex: 'type', align: XAlignType.Center }),
      XCol.Create({ col: 6, text: 'Ref. #', width: 120, dataIndex: 'refNo'}),
      XCol.Create({ col: 7, text: 'MBL/MAWB #', width: 120, dataIndex: 'mblNo'}),
      XCol.Create({ col: 8, text: 'HBL/HAWB #', width: 120, dataIndex: 'hblNo'}),
      XCol.Create({ col: 9, text: 'Dropped by', width: 110, dataIndex: 'droppedBy'}),
      XCol.Create({ col: 10, text: 'Review', width: 120, dataIndex: 'actionNo'}),
      XCol.Create({ col: 11, text: 'Error', width: 300, dataIndex: 'error'}),
    ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
    
    public static OrderBy = { orderBy: AiCenterListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: AiCenterListItem[]) {
      return data.map((d: AiCenterListItem) => ({
          ...d,
        }));
      // move to selectquery
      // data.forEach((d: AiCenterListItem) => {
      //   switch(d.jobName) {
      //     case JobNames.ISF: 
      //       d.actionNo = d.shipmentId; 
      //       break;

      //     case JobNames.OIMbl:
      //     case JobNames.OEMbl:
      //     case JobNames.AIMbl:
      //     case JobNames.AEMbl:
      //     case JobNames.OtherOP:
      //       d.actionNo = d.mblNo;
      //       break;

      //     case JobNames.OIHbl: 
      //     case JobNames.OEHbl:
      //     case JobNames.AIHbl:
      //     case JobNames.AEHbl:
      //       d.actionNo = d.hblNo;
      //       break;
          
      //     case JobNames.Invoice:
      //     case JobNames.Bill:
      //     case JobNames.CrDb:
      //       d.actionNo = d.invoiceNo;
      //       break;
      //     default:
      //       break;
      //   }
      // });
      // return data;
    }

    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
      createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
    }
}